import styles from "./tenantcard.module.css";
import { useState } from "react";
import TransactionSummary from "./components/TransactionSummary";
import TenantJourney from "./components/TenantJourney";
import TenantContactInfo from "./components/TenantContactInfo";
import TenantCardHeader from "./components/TenantCardHeader";
import TenantDetails from "./components/TenantDetails";
import { useAuth0 } from "@auth0/auth0-react";

const TenantCard = ({ tenantData, setTenantData, setLoading, setSnackbarOpen, setSnackbarMsg, setShowAddForm, setActiveTenant, activeTenant, setIsAddForm, setShowMoveoutForm }) => {
  const { user, isAuthenticated } = useAuth0();
  const [expanded, setExpanded] = useState("panel1");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  }

  return (<>
    <div className={`${styles.SMProCusSmallDiv}`}>
      <div className={`${styles.CardSmall}`}>

        <TenantCardHeader tenantData={tenantData} activeTenant={activeTenant} setActiveTenant={setActiveTenant.bind(this)} setTenantData={setTenantData.bind(this)} setShowAddForm={setShowAddForm.bind(this)} setLoading={setLoading.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setIsAddForm={setIsAddForm.bind(this)} setShowMoveoutForm={setShowMoveoutForm.bind(this)} />

        <div className="HistoryAccording Theme">

          {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant-contactinfo:read") > -1 && <TenantContactInfo tenantData={tenantData} activeTenant={activeTenant} expanded={expanded} handleChange={handleChange.bind(this)} setLoading={setLoading.bind(this)} />}

          {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant-journey:read") > -1 && tenantData?.all_tenants[0]?.prospect && <TenantDetails tenantId={tenantData?.all_tenants[activeTenant]?.id} prospectData={tenantData?.all_tenants[activeTenant]?.prospect} expanded={expanded} handleChange={handleChange.bind(this)} setLoading={setLoading.bind(this)} />}

          {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant-journey:read") > -1 && <TenantJourney tenantData={tenantData} expanded={expanded} handleChange={handleChange.bind(this)} setLoading={setLoading.bind(this)} />}

          {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant-journey:read") > -1 && <TransactionSummary tenantData={tenantData} expanded={expanded} handleChange={handleChange.bind(this)} />}

        </div>
      </div>
    </div>
  </>);
};

export default TenantCard;